import axios from "../../config/axiosConfig";
import { CREATE_LOT, GET_LOT, LOT_REQUEST, DELETE_LOT, UPDATE_LOT, LOT_REQUEST_FAILURE } from "../types";
import { addMasterInOption, updateMasterInOption } from "./master-options-actions";

export const getLots = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LOT_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/lot/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_LOT, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: LOT_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: LOT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createLot = (lot) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: LOT_REQUEST });
      return axios.post("/lot/add", lot,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_LOT, payload: response.data });
          dispatch(addMasterInOption('lots', response.data));
        } else {
          dispatch({
            type: LOT_REQUEST_FAILURE,
            error: "Lot create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: LOT_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: LOT_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
      throw error;
    }
  };
};

export const updateLot = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LOT_REQUEST });
      const { auth } = getState();
      return axios.put("/lot/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_LOT,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('lots', id, response.data));
        } else {
          dispatch({
            type: LOT_REQUEST_FAILURE,
            error: "Lot update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: LOT_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: LOT_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
      throw error;
    }
  };
};

export const deleteLot = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOT_REQUEST });
      return axios.delete(`/lot/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_LOT, id: id });
          dispatch(updateMasterInOption('lots', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: LOT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: LOT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
